// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "c5c17f161676d0163f44" + "-11.13.0-58448c1-202504251351.js";
};